import styled from 'styled-components';
import { Typography } from '../typography/Typography';

export const NumberTypography = styled(Typography).withConfig({ displayName: 'NumberTypography' })`
    font-variant-numeric: proportional-nums;
`;
